//HOME PAGE STROIES JSON START
const storyAndSetting = {
    settings: {
      displayDesktop: true,
      displayMobile: true,
    },
    story: [

      {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/zip-folio-brown_201x.jpg?v=1619189427",
        target: "_self",
        title: "ZIP FOLIO",
        url: "/collections/zippered-leather-portfolio",
      }, 
            {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/zip-pen-case-5.jpg?v=1619189427",
        target: "_self",
        title: "ZIP PEN CASE",
        url: "/collections/zippered-pen-pencil-cases",
      },
      
     {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/a6-leather-notebook-covers_201x.jpg",
        target: "_self",
        title: "SLIM COVERS",
        url: "/collections/slim-notebook-covers",
      },

      {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/hard-pen-case-galen_201x.jpg",
        target: "_self",
        title: "MAGN. OPUS",
        url: "/collections/magnum-opus-pen-cases",
      }, 

      
      {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/tomor-river-notebook-400pages_201x.jpg?v=1619189427",
        target: "_self",
        title: "NOTEBOOKS",
        url: "/collections/notebooks",
      },      
          {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/portable-writing-desk_201x.jpg?v=1619532948",
        target: "_self",
        title: "WRITING BOX",
        url: "/products/the-writing-box",
      },     
      
       {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/medic-bag_201x.jpg?v=1619189427",          
        target: "_self",
        title: "MEDIC BAG",
        url: "/collections/writers-medic-bag",
      },     
      
      {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/Travelers-journal_201x.jpg?v=1619189427",
        target: "_self",
        title: "TRAVELERS",
        url: "/collections/travelers-notebooks",
      },

      
{
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/fountain-pen-galen-1_201x.jpg?v=1742048889",          
        target: "_self",
        title: "FOUNTAIN PEN",
        url: "/collections/fountain-pens",
      },      
      
      {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/brass-measure-tools_201x.jpg?v=1619533298",
        target: "_self",
        title: "MEASURE",
        url: "/collections/brass-accessories",
      },
      
      
            {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/pen-display-cases_201x.jpg?v=1619532678",
        target: "_self",
        title: "PEN DISPLAY",
        url: "/collections/wooden-pen-cases",
      },


      {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/flap-pen-case-brown_201x.jpg?v=1619189427",
        target: "_self",
        title: "FLAP PEN CASE",
        url: "/collections/leather-flap-pen-cases",
      },
      
    {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/wooden-pen-holder_201x.jpg?v=1619533878",
        target: "_self",
        title: "PEN HOLDER",
        url: "/collections/wooden-pen-holders",
      },        
      
      {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/washi-tape-holder-2_201x.jpg?v=1619531546",
        target: "_self",
        title: "WASHI DISP",
        alt: "washi tape dispenser",
        url: "/collections/washi-tape-dispensers",
      },
      
            {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/leather-notebook_0eb09069-4eb0-4690-b09b-c76a2f3cb38e_201x.jpg?v=1619189427",
        target: "_self",
        title: "L. NOTEBOOKS",
        url: "/collections/leather-notebooks",
      }      
      ,

            {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/travlers-notebook-refill-menu_201x.jpg?v=1619973298",
        target: "_self",
        title: "TN REFILLS",
        url: "/collections/travelers-notebook-refill",
      }      
      ,
      
            {
        img:
          "https://cdn.shopify.com/s/files/1/0575/7177/files/leather-balm-care_201x.jpg?v=1619534813",
        target: "_self",
        title: "CARE",
        url: "/collections/leather-care-and-repair",
      }

      
    ],
  };
  //HOME PAGE STROIES JSON END
  
  //HOME PAGE STROIES HTML START
  function storyHtml(stories) {
    let storiesHtml = "";
    stories.story.forEach((item) => {
      storiesHtml +=
        '<a href="' +
        item.url +
        '" _target="' +
        item.target +
        '" class="story">' +
        "<img " +
        'src="' +
        item.img +
        '"' +
        'alt="' +
        item.title +
        '"' +
        'class="img"' +
        "/>" +
        '<p class="title">' +
        item.title +
        "</p>" +
        "</a>";
    });
    return storiesHtml;
  }
  //HOME PAGE STROIES HTML END
  
  $(document).ready(function () {
    if ($("body").width() > 1366 && storyAndSetting.settings.displayDesktop) {
      $(".social-stories:first").append(storyHtml(storyAndSetting));
    } else if (
      $("body").width() < 1366 &&
      storyAndSetting.settings.displayMobile
    ) {
      $(".social-stories:first").append(storyHtml(storyAndSetting));
    }
  });
  


 